const CustomNotification = ({message, children}: any) => {
    return (
        <div className="custom-notification">
            {message ? (
                <div dangerouslySetInnerHTML={{__html: message}}></div>
            ) : null}
            <div>{children}</div>
        </div>
    )
}

export default CustomNotification;